module.exports = __webpack_public_path__ + "img/ML.6a716494.svg";